<template>
  <v-app>
    <Header />
    <MobileMenu />
    <v-main class="main-content">
      <router-view></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "./components/global/Footer";
import Header from "./components/global/Header";
import MobileMenu from "./components/global/MobileMenu";
import { mapGetters } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapGetters(["auth", "header"]),
  },
  components: {
    Footer,
    Header,
    MobileMenu,
  },
  data: () => ({}),
};
</script>

<style lang="scss">
.link a,
a.link {
  text-decoration: none;
  color: rgb(153, 27, 30) !important;
}

a.link:hover,
.link a:hover {
  text-shadow: 0px 0px 1px rgb(153, 27, 30);
}

html,
body {
  height: 100%;
}

.main-content {
  min-height: calc(100vh - 220px);
  margin-bottom: 30px;
}

.expansion-header {
  font-weight: bold;
  background: rgb(241, 241, 241);
}

.expansion-content > * {
  padding-top: 10px !important;
}

.expansion-subsection {
  padding: 10px 10px;
}

.expansion-subtitle {
  margin-bottom: 10px;
}

.expansion-li {
  margin-left: 10px;
}

.none-fluid {
  max-width: 1140px;
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
  .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
</style>